export default (state = [], action) => {
	switch (action.type) {
		case 'BANK_ACCOUNT_DETAILS_DATA':
			return action.data;
		default:
			return state;
	}
};

export const action = {
	data: data => ({ type: 'BANK_ACCOUNT_DETAILS_DATA', data }),
};
